import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Clear } from '@mui/icons-material';
import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { isEmpty, isEqual } from 'lodash';

import AutocompleteCustom from '../../../../components/custom/CustomAutocomplete/CustomAutocomplete';
import DateTimePicker from '../../../../components/date-time/DateTimePicker/DateTimePicker';
import InputAdornmentLoading from '../../../../components/input-adorment/InputAdornmentLoading/InputAdornmentLoading';
import PopperAutoWidth from '../../../../components/popper/PopperAutoWidth/PopperAutoWidth';
import { contactList } from '../../../../store/contact/contact.action';
import { clearContactData } from '../../../../store/contact/contact.slice';
import { getExpenseList } from '../../../../store/expense/expense.action';
import messageHelper from '../../../../store/message/message.helper';
import {
  STATUS_REQUEST_LIST_CONTACT_DATA_PENDING,
  STATUS_REQUEST_LIST_EXPENSE_PENDING,
} from '../../../../utils/constants/store.constant';
import { initialSearchExpense } from '../../../../utils/data/display/initial-search-expense';
import { columnsSearchWithDate } from '../../../../utils/data/display/table-list-expense';
import { TERSIER_DEFAULT_LIST_PARAMS } from '../../../../utils/default/params.default';
import autocompleteHelper from '../../../../utils/helpers/component/autocomplete.helpers';
import dateHelpers from '../../../../utils/helpers/date.helpers';
import formatHelp from '../../../../utils/helpers/format.helpers';
import objHelper from '../../../../utils/helpers/object.helper';

import { styles } from './TableHeadSearchExpense.styles';

class TableHeadSearchExpense extends Component {
  constructor(props) {
    super(props);

    const { t } = props;

    this.state = {
      searchParams: {
        ...initialSearchExpense(t),
      },
      focusedInputName: null,
      selectedAutocompleteName: null,
    };

    this.searchExpenseTimeoutID = null;

    this.handleClearSingleFilter = this.handleClearSingleFilter.bind(this);

    // handling search by input
    this.handleOnChangeInput = this.handleOnChangeInput.bind(this);

    this.handleOnOpenAutocomplete = this.handleOnOpenAutocomplete.bind(this);
    this.handleOnCloseAutocomplete = this.handleOnCloseAutocomplete.bind(this);
    this.handleChangeAutocomplete = this.handleChangeAutocomplete.bind(this);
  }

  async handleClearSingleFilter(event) {
    const { name } = event.currentTarget;

    const { searchParams: currSearchParams } = this.state;

    const newSearchParams = {
      ...currSearchParams,
      [name]: '',
    };

    this.setState((prevState) => ({
      ...prevState,
      searchParams: {
        ...newSearchParams,
      },
    }));

    const { expense } = this.props;
    const { expenseList } = expense;

    if (expense.statusRequest === STATUS_REQUEST_LIST_EXPENSE_PENDING) {
      return;
    }

    const paginate = expenseList ? expenseList.per_page : 20;

    await this.props.getExpenseList({
      paginate,
      ...newSearchParams,
    });
  }

  handleOnChangeDate(newValueDate) {
    const { searchParams: currSearchParams } = this.state;

    const isDateValueNotChanged = isEqual(
      newValueDate,
      objHelper.filterKeyObj(currSearchParams, [], columnsSearchWithDate),
    );

    if (isDateValueNotChanged) return;

    if (!isEmpty(newValueDate)) {
      const { from_date, to_date } = newValueDate;

      if (
        !dateHelpers.isValidDateV2(new Date(from_date)) ||
        !dateHelpers.isValidDateV2(new Date(to_date))
      ) {
        const { t } = this.props;

        this.props.setFailedMessage(
          t('dashboard.sales.sales-quotation.message.invalid-date-format.primary'),
          t('dashboard.sales.sales-quotation.message.invalid-date-format.secondary'),
        );

        return;
      }
    }

    const newSearchParams = {
      ...currSearchParams,
      ...newValueDate,
    };

    this.setState((prevState) => ({
      ...prevState,
      searchParams: {
        ...newSearchParams,
      },
    }));

    if (this.searchExpenseTimeoutID) {
      clearTimeout(this.searchExpenseTimeoutID);
    }

    this.searchExpenseTimeoutID = setTimeout(async () => {
      const { expense } = this.props;
      const { expenseList } = expense;

      const paginate = expenseList ? expenseList.per_page : 20;

      return await this.props.getExpenseList({
        paginate,
        ...newSearchParams,
      });
    }, 750);
  }

  handleOnChangeInput(event) {
    const { name, value } = event.target;

    const { searchParams: currSearchParams } = this.state;

    const newSearchParams = {
      ...currSearchParams,
      [name]: value,
    };

    this.setState((prevState) => ({
      ...prevState,
      searchParams: {
        ...newSearchParams,
      },
      focusedInputName: name,
    }));

    if (this.searchExpenseTimeoutID) {
      clearTimeout(this.searchExpenseTimeoutID);
    }

    this.searchExpenseTimeoutID = setTimeout(async () => {
      const { expense } = this.props;
      const { expenseList } = expense;

      const paginate = expenseList ? expenseList.per_page : 20;

      return await this.props.getExpenseList({
        paginate,
        ...newSearchParams,
      });
    }, 750);

    if (name === 'contact_id') {
      const { value } = event.target;

      const { contact } = this.props;

      if (contact.statusRequest === STATUS_REQUEST_LIST_CONTACT_DATA_PENDING) {
        return;
      }

      if (this.searchExpenseTimeoutID) {
        clearTimeout(this.searchExpenseTimeoutID);
      }

      this.searchExpenseTimeoutID = setTimeout(async () => {
        return await this.props.getListContact({
          ...TERSIER_DEFAULT_LIST_PARAMS,
          // type: [ 'is_customer' ],
          contact_name: value,
        });
      }, 750);
    }
  }

  async handleOnOpenAutocomplete(event, name) {
    event.preventDefault();

    if (name) {
      this.setState((prevState) => ({
        ...prevState,
        selectedAutocompleteName: name,
      }));
    }

    const { contact } = this.props;

    if (
      name === 'contact_id' &&
      contact.statusRequest !== STATUS_REQUEST_LIST_CONTACT_DATA_PENDING
    ) {
      await this.props.getListContact({
        ...TERSIER_DEFAULT_LIST_PARAMS,
        // type: ['is_customer']
      });
    }
  }

  async handleOnCloseAutocomplete(event, name) {
    if (name === 'contact_id') {
      await this.props.clearContactData();
    }

    this.setState((prevState) => ({
      ...prevState,
      selectedAutocompleteName: '',
    }));
  }

  async handleOnScrollAutocomplete(name) {
    if (name === 'contact_id') {
      const { contact } = this.props;
      const { contactData } = contact;

      if (!contactData) return;

      const {
        current_page: page,
        next_page_url,
        per_page: paginate,
        search_contact_name: contact_name,
      } = contactData;

      if (!next_page_url) return;

      await this.props.getListContact({
        page: page + 1,
        paginate,
        // type: ['is_customer'],
        contact_name,
        isRewriteAll: false,
      });
    }
  }

  async handleChangeAutocomplete(
    event,
    newValue,
    containerName,
    secondaryName,
    valueSecondaryKey,
    name,
  ) {
    event.preventDefault();

    const { searchParams: currSearchParams } = this.state;

    if (name === 'contact_id') {
      const newSearchParams = {
        ...currSearchParams,
        [name]: newValue,
        contact_name: !isEmpty(newValue) ? newValue.contact_name : '',
        contact_name_container: newValue,
      };

      this.setState((prevState) => ({
        ...prevState,
        searchParams: {
          ...newSearchParams,
        },
      }));

      const { expense } = this.props;
      const { expenseList } = expense;

      const paginate = expenseList ? expenseList.per_page : 20;

      return await this.props.getExpenseList({
        paginate,
        ...newSearchParams,
      });
    }
  }

  render() {
    const { searchParams, focusedInputName, selectedAutocompleteName } = this.state;

    const { t, i18n, classes, dataHeaders, expense, contact } = this.props;

    const { language } = i18n;

    // value for contact autocomplete
    const { contact_name_container } = searchParams;

    const { contactData } = contact;

    let contactDataList = [];

    let paginateContactData = TERSIER_DEFAULT_LIST_PARAMS.paginate;

    if (contactData) {
      if (Array.isArray(contactData.data)) {
        contactDataList = contactData.data;
      }

      paginateContactData = contactData.per_page;
    }

    const isExpenseLoading = expense.statusRequest === STATUS_REQUEST_LIST_EXPENSE_PENDING;

    return (
      <TableHead className={classes.TableHeadMainContainer}>
        <TableRow>
          {dataHeaders &&
            dataHeaders.map((dataHeader, index) => {
              if (!dataHeader.name_input) {
                return (
                  <TableCell
                    key={index}
                    align={dataHeader.align}
                    style={{
                      verticalAlign: 'top',
                      alignItems: 'flex-end',
                      width: dataHeader.width,
                      minWidth: dataHeader.minWidth,
                      maxWidth: dataHeader.maxWidth,
                    }}
                    className={classes.tableCellMain}
                  >
                    <p>{dataHeader.label}</p>
                  </TableCell>
                );
              }

              // table header for date
              if (columnsSearchWithDate.includes(dataHeader.name_input)) {
                return (
                  <TableCell
                    key={index}
                    align={dataHeader.align}
                    style={{
                      width: dataHeader.width,
                      minWidth: dataHeader.minWidth,
                      maxWidth: dataHeader.maxWidth,
                    }}
                    className={classes.tableCellMain}
                  >
                    <p>{dataHeader.label}</p>
                    <DateTimePicker
                      startDate={searchParams['from_date']}
                      endDate={searchParams['to_date']}
                      textCancel={t('button.cancel')}
                      textApply={t('button.apply')}
                      placeHolderInput={dataHeader.placeholder}
                      onSelectedChange={(value) => this.handleOnChangeDate(value)}
                      locale={language}
                      defaultKeyStartDate={'from_date'}
                      defaultKeyEndDate={'to_date'}
                      isDisabledInput={isExpenseLoading}
                    />
                  </TableCell>
                );
              }

              // table header for contact
              if (dataHeader.name_input === 'contact_name') {
                return (
                  <TableCell
                    key={index}
                    align={dataHeader.align}
                    style={{ width: dataHeader.width }}
                    className={classes.tableCellMain}
                  >
                    <p>{dataHeader.label}</p>
                    <FormControl>
                      <AutocompleteCustom
                        id='contact_id'
                        name='contact_id'
                        size='small'
                        sx={{ width: 250 }}
                        options={contactDataList}
                        value={contact_name_container}
                        autoHighlight={true}
                        isPaginated={true}
                        totalOptions={autocompleteHelper.getOptionPaginatedAutocomplete(
                          contactDataList,
                          paginateContactData,
                          3,
                        )}
                        PopperComponent={PopperAutoWidth}
                        onOpen={(event) => this.handleOnOpenAutocomplete(event, 'contact_id')}
                        onClose={(event) => this.handleOnCloseAutocomplete(event, 'contact_id')}
                        onChange={(event, newValue) =>
                          this.handleChangeAutocomplete(event, newValue, '', '', '', 'contact_id')
                        }
                        ListboxProps={{
                          onScroll: (event) => {
                            // i need scroll into bottom view when api was hitted
                            const { offsetHeight, scrollHeight, scrollTop } = event.target;

                            const isEndOfScroll = offsetHeight + scrollTop === scrollHeight;

                            if (isEndOfScroll) {
                              this.handleOnScrollAutocomplete('contact_id');
                            }
                          },
                        }}
                        getOptionLabel={(option) =>
                          autocompleteHelper.getInputValue(
                            option,
                            ['contact_code', 'contact_name'],
                            ['contact_name'],
                            formatHelp.contactCodeWithName,
                          )
                        }
                        isOptionEqualToValue={(option, value) =>
                          autocompleteHelper.isOptionEqualToValue(option, value, 'contact_id')
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name='contact_id'
                            placeholder={t(
                              'dashboard.sales.sales-quotation.input.search-customer.placeholder',
                            )}
                            disabled={this.isActionMenuUpdate}
                            onChange={this.handleOnChangeInput}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornmentLoading
                                  isLoading={
                                    selectedAutocompleteName === 'contact_id' &&
                                    contact.statusRequest ===
                                      STATUS_REQUEST_LIST_CONTACT_DATA_PENDING
                                  }
                                  defaultInputAdornment={params.InputProps.endAdornment}
                                />
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </TableCell>
                );
              }

              return (
                <TableCell
                  key={index}
                  align={dataHeader.align}
                  style={{
                    width: dataHeader.width,
                    minWidth: dataHeader.minWidth,
                    maxWidth: dataHeader.maxWidth,
                  }}
                  className={classes.tableCellMain}
                >
                  <p>{dataHeader.label}</p>
                  <FormControl>
                    <OutlinedInput
                      name={dataHeader.name_input}
                      autoFocus={dataHeader.name_input === focusedInputName}
                      size='small'
                      placeholder={dataHeader.placeholder}
                      onChange={this.handleOnChangeInput}
                      value={searchParams[dataHeader.name_input]}
                      {...(searchParams[dataHeader.name_input] && {
                        endAdornment: (
                          <InputAdornment
                            position='end'
                            className={classes.inputAdornmentClearSingleFilter}
                          >
                            {searchParams[dataHeader.name_input] && (
                              <IconButton
                                edge='end'
                                name={dataHeader.name_input}
                                className={classes.iconButtonContainerClear}
                                onClick={this.handleClearSingleFilter}
                              >
                                <Clear fontSize='10px' />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      })}
                    />
                  </FormControl>
                </TableCell>
              );
            })}
        </TableRow>
      </TableHead>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    expense: state.expense,
    contact: state.contact,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getExpenseList: (paramsGetListExpense) => dispatch(getExpenseList(paramsGetListExpense)),
    getListContact: (paramsGetListContact) => dispatch(contactList(paramsGetListContact)),
    clearContactData: () => dispatch(clearContactData()),
    setFailedMessage: (primaryText, secondaryText) =>
      messageHelper.failedMessage(dispatch, primaryText, secondaryText, false),
  };
};

// add style into component
const stylingTableHeadSearchExpense = withStyles(styles)(TableHeadSearchExpense);

// add translation into component
const TableHeadSearchExpenseTranslate = withTranslation()(stylingTableHeadSearchExpense);

// connect with style and action into component
const ConnectedTableHeadSearchExpense = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableHeadSearchExpenseTranslate);

export default ConnectedTableHeadSearchExpense;
